import SvgIcon from '../SvgIcon';
import * as React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { Badge } from '../../containers/Badges/Models';
import { useIntl } from 'react-intl';

export interface BadgeProps extends Badge {
  readonly isAchieved: boolean;
}

const BadgeTitle = styled.span`
  color: ${p => p.theme.color.black2};
  font-size: ${p => p.theme.font.size.small};
  margin-top: 10px;
  width: 80px;
  text-align: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const IconContainer = styled.div`
  border: 1px solid ${p => p.theme.color.paleBlue};
  border-radius: 50%;
  padding: 12px;
  &:hover {
    border-color: ${p => p.theme.color.cerulean};
  }
`;

const MPToolTip = styled(ReactTooltip)`
  border: 1px solid ${p => p.theme.color.paleBlue} !important;
  &::before {
    border-top-color: ${p => p.theme.color.paleBlue} !important;
  }
`;

export const BadgeComponent = (props: BadgeProps) => {
  const intl = useIntl();

  const messageBase = 'components.Badges';

  const title = intl.formatMessage({
    id: `${messageBase}.${props.id}.title`,
  });

  const description = intl.formatMessage({
    id: `${messageBase}.${props.id}.description`,
  });

  const disabledDescription = intl.formatMessage({
    id: `${messageBase}.${props.id}.disabled_description`,
  });

  const iconName = props.isAchieved ? props.id : `${props.id}-disabled`;
  const tooltipText = props.isAchieved ? description : disabledDescription;

  return (
    <Container data-tip={true} data-for={props.id}>
      <IconContainer>
        <SvgIcon iconName={iconName} iconWidth={60} iconHeight={60} />
      </IconContainer>
      <BadgeTitle>{title}</BadgeTitle>
      <MPToolTip id={props.id} effect="solid" type={'light'} border={true}>
        <span>{tooltipText}</span>
      </MPToolTip>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/Badge/index.tsx